<div class="search-widget">
  <app-search-widget-wrapper
    [customCssClass]="customCssClass()"
    [hideFiltersAndPlacePanel]="hideFiltersAndPlacePanel()"
    [inferredCareProviderTypeAreaId]="inferredCareProviderTypeAreaId()"
    [inferredCategoryTypeId]="inferredCategoryTypeId()"
    [isOnTop]="topSpacerInViewport()"
    [mainCareProviderTypeId]="mainCareProviderTypeId()"
    [pageType]="pageType()"
    [theme]="searchWidgetThemeEnum.DEFAULT"
  ></app-search-widget-wrapper>
</div>

@if(fixedWidget()) {
  <app-top-content-space (topSpacerInViewportUpdated)="handleTopSpacerInViewport($event)"></app-top-content-space>
}

